/*
 * Confidential and Proprietary.
 * Do not distribute without 1-800-Flowers.com, Inc. consent.
 * Copyright 1-800-Flowers.com, Inc. 2019. All rights reserved.
 */

export const billingFormLabel = {
    firstName: 'First Name',
    lastName: 'Last Name',
    email: 'Email',
    address1: 'Billing Address',
    zipCode: 'Zip Code',
    city: 'City',
    state: 'State',
    phone: 'Phone',
    country: 'Country',
};

export const KlarnaErrorFields = {
    'billing_address.given_name': 'firstName',
    'billing_address.family_name': 'lastName',
    'billing_address.email': 'email',
    'billing_address.street_address': 'address1',
    'billing_address.street_address2': 'address2',
    'billing_address.postal_code': 'zipCode',
    'billing_address.city': 'city',
    'billing_address.region': 'state',
    'billing_address.phone': 'phone',
    'billing_address.country': 'country',
};

const removeMaskForPhoneNumber = (number) => {
    let strNumber = number.toString().trim();
    strNumber = strNumber.replace(/\s/g, '').replace(/[^0-9+]/g, '');
    if (strNumber.indexOf('+') === 0 && strNumber.indexOf('1') === 1) {
        strNumber = strNumber.substring(2, strNumber.length);
    } else if (strNumber.indexOf('+') >= 0) {
        strNumber = strNumber.replace(/\s/g, '').replace(/[^0-9]/g, '');
    }
    return strNumber;
};

export const convertDollarToCent = (amount) => Math.ceil(amount * 100);

export const validateMandatoryFields = (address) => {
    const fields = ['firstName', 'lastName', 'email', 'address1', 'zipCode', 'city', 'state', 'phone', 'country'];
    const fieldError = {};
    console.log('address', address);
    fields.forEach((fieldName) => {
        if (!address[fieldName]) {
            fieldError[fieldName] = `${billingFormLabel[fieldName]} is required`;
        } else if (fieldName === 'country' && address[fieldName] !== 'US') {
            fieldError[fieldName] = 'Klarna payment requires US address';
        } else if (fieldName === 'phone') {
            const phone = removeMaskForPhoneNumber(address[fieldName]);
            if (phone?.length < 10) {
                fieldError[fieldName] = 'Invalid phone number';
            }
        }
    });

    return fieldError;
};

export const getFormattedBillingAddress = (address, isUseKlarnaOrganizationField) => {
    const formatBillingAddress = {
        given_name: address.firstName || '',
        family_name: address.lastName || '',
        email: address.email || '',
        street_address: address.address1 || '',
        street_address2: address.address2 || '',
        postal_code: address.zipCode || '',
        city: address.city || '',
        region: address.state || '',
        phone: address.phone ? removeMaskForPhoneNumber(address.phone) : '',
        country: address.country || '',
    };

    if (isUseKlarnaOrganizationField && address.organizationName) {
        formatBillingAddress.organization_name = address.organizationName;
    } else if (!isUseKlarnaOrganizationField && address.organizationName) {
        formatBillingAddress.street_address2 = `${formatBillingAddress.street_address2}, ${address.organizationName}`;
    }

    return formatBillingAddress;
};

export const getFormattedShippingAddress = (shippingAddress, BillingAddress, isUseKlarnaOrganizationField) => {
    const formatShippingAddress = {
        given_name: shippingAddress.given_name || '',
        family_name: shippingAddress.family_name || '',
        street_address: shippingAddress.street_address || '',
        street_address2: shippingAddress.street_address2 || '',
        postal_code: shippingAddress.postal_code || '',
        city: shippingAddress.city || '',
        region: shippingAddress.region || '',
        country: shippingAddress.country || '',
        phone: BillingAddress.phone || '',
        email: BillingAddress.email || '',
    };

    if (isUseKlarnaOrganizationField && shippingAddress.organization_name) {
        formatShippingAddress.organization_name = shippingAddress.organization_name;
    }

    return formatShippingAddress;
};

export const getPayloadKlarnaAuthorizePayment = (orderTotal, billingAddress, klarnaSessionResponse, isUseKlarnaOrganizationField) => {
    const purchaseCountry = 'US';
    const purchaseCurrency = 'USD';
    const locale = 'en-US';
    const formatedBillingAddress = getFormattedBillingAddress(billingAddress, isUseKlarnaOrganizationField);

    const authorizePayload = {
        purchase_country: purchaseCountry,
        purchase_currency: purchaseCurrency,
        locale,
        billing_address: formatedBillingAddress,
        order_amount: convertDollarToCent(orderTotal),
        order_lines: klarnaSessionResponse.order_lines,
        shipping_address: getFormattedShippingAddress(klarnaSessionResponse.shipping_address, formatedBillingAddress, isUseKlarnaOrganizationField),
    };

    if (klarnaSessionResponse?.attachment?.body?.length > 0) {
        const attachment = klarnaSessionResponse.attachment;

        authorizePayload.attachment = attachment;
    }

    return authorizePayload;
};
